import { action } from 'typesafe-actions'
import { CreateAccountResponse } from '../../models/ResponseModel'
import { ActionTypes } from './types'

export const onChange = (payload: any) => action(ActionTypes.ON_CHANGE, payload)

export const createAccountRequest = (payload: any) =>
  action(ActionTypes.CREATE_ACCOUNT_REQUEST, payload)

export const createAccountFulfilled = (payload: CreateAccountResponse) =>
  action(ActionTypes.CREATE_ACCOUNT_FULFILLED, payload)

export const payment3DSFulfilled = (payload: any) =>
  action(ActionTypes.PAYMENT_3DS_FULLFILLED, payload)

export const lawyerResponseClear = () => action(ActionTypes.LAWYER_RESPONSE_CLEAR)

export const lawyerQueryRequest = (payload: any) =>
  action(ActionTypes.LAWYER_QUERY_REQUEST, payload)

export const lawyerQueryFulfilled = (payload: any) =>
  action(ActionTypes.LAWYER_QUERY_FULFILLED, payload)

export const stepInfoCheckRequest = (payload: any) =>
  action(ActionTypes.STEP_INFO_CHECK_REQUEST, payload)

export const stepInfoCheckFulfilled = (payload: any) =>
  action(ActionTypes.STEP_INFO_CHECK_FULFILLED, payload)

export const previewDealerContractRequest = (payload: any) =>
  action(ActionTypes.PREVIEW_DEALER_CONTRACT_REQUEST, payload)

export const previewDealerContractFulfilled = (payload: any) =>
  action(ActionTypes.PREVIEW_DEALER_CONTRACT_FULFILLED, payload)

export const previewDealerContractRejected = (payload: any) =>
  action(ActionTypes.PREVIEW_DEALER_CONTRACT_REJECTED, payload)

export const signDealerContractRequest = (payload: any) =>
  action(ActionTypes.SIGN_DEALER_CONTRACT_REQUEST, payload)

export const signDealerContractFulfilled = (payload: any) =>
  action(ActionTypes.SIGN_DEALER_CONTRACT_FULFILLED, payload)
export const signDealerContractRejected = () => action(ActionTypes.SIGN_DEALER_CONTRACT_REJECTED)

export const previewCampainContractRequest = (payload: any) =>
  action(ActionTypes.PREVIEW_CAMPAIN_CONTRACT_REQUEST, payload)

export const previewCampainContractRejected = (payload: any) =>
  action(ActionTypes.PREVIEW_CAMPAIN_CONTRACT_REJECTED, payload)

export const previewCampainContractFulfilled = (payload: any) =>
  action(ActionTypes.PREVIEW_CAMPAIN_CONTRACT_FULFILLED, payload)

export const signCampainContractRequest = (payload: any) =>
  action(ActionTypes.SIGN_CAMPAIN_CONTRACT_REQUEST, payload)

export const signCampainContractFulfilled = (payload: any) =>
  action(ActionTypes.SIGN_CAMPAIN_CONTRACT_FULFILLED, payload)

export const signCampainContractRejected = () => action(ActionTypes.SIGN_CAMPAIN_CONTRACT_REJECTED)
